import { palettePrimaryMain as PRIMARY } from '@/theme/designTokens'

/** Figma 4398:5866 / 4398:5872 — 44×24 track, #e5e7ea off, thumb 20px; on = primary fill */
export const DISPLAY_SWITCH_SX = {
  width: 44,
  height: 24,
  p: 0,
  '& .MuiSwitch-switchBase': {
    p: 0,
    m: '2px',
    transitionDuration: '200ms',
    '&.Mui-checked': {
      transform: 'translateX(20px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: PRIMARY,
        opacity: 1,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 20,
    height: 20,
    boxShadow: 'none',
    backgroundColor: '#fff',
  },
  '& .MuiSwitch-track': {
    borderRadius: '12px',
    backgroundColor: '#e5e7ea',
    opacity: 1,
  },
} as const
